import logoNimella from '../../kuvat/logo_nimella.png';
import './LogoNimella.css';

export default function LogoNimella() {
  return <img className="logo" src={logoNimella} alt={'logo'} />;
}
